import React, { FC, useRef, useState } from 'react';

//devextreem
import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import { AppGroup, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { DateBox, NumberBox } from 'devextreme-react';

import { useConfirmRequestWorkOutCheckTimeMutation } from 'bus/request';
import { ConfirmRequestWorkOutCheckTimeRequest, RequestWorkOutCheckTime } from 'bus/request/types';

type Props = {
  requestWorkId: number;
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  onRefresh: () => void;
  requestWork?: RequestWorkOutCheckTime;
};

const initialForm: Omit<ConfirmRequestWorkOutCheckTimeRequest, 'requestWorkId'> = {
  checkOutTime: new Date(),
  transportWeight: 0,
};

const AutoFillModal: FC<Props> = ({ changeVisible, onRefresh, visible, requestWorkId, requestWork }) => {
  let createGroupValidationRef = useRef<ValidationGroup>(null);

  const [form, setForm] = useState<Omit<ConfirmRequestWorkOutCheckTimeRequest, 'requestWorkId'>>(initialForm);

  const onHidden = () => {
    createGroupValidationRef.current?.instance.reset();
    setForm(initialForm);
  };

  const [confirmRequestWorkOutCheckTime, { isLoading }] = useConfirmRequestWorkOutCheckTimeMutation();

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();

    if (createGroupValidationRef.current?.instance.validate().isValid) {
      await confirmRequestWorkOutCheckTime({ ...form, requestWorkId });
      changeVisible(false);
      onRefresh();
    }
  };

  const handleHideModal = () => {
    changeVisible(false);
  };

  const handleShown = () => {
    if (requestWork) setForm({ checkOutTime: requestWork.checkOutTime, transportWeight: requestWork.weightAfter });
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={handleHideModal}
        onShowing={handleShown}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Подтверждение отгрузки"
        width={400}
        onHidden={onHidden}
        height="auto"
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit}>
              <ValidationGroup ref={createGroupValidationRef}>
                <Form formData={form}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppRow>
                      <AppGroup col={12}>
                        <AppFiledBox label="Дата и время отгрузки" labelTop>
                          <DateBox
                            stylingMode="underlined"
                            type="datetime"
                            onValueChange={(e) => setForm((prev) => ({ ...prev, checkOutTime: e as string }))}
                            useMaskBehavior
                            dateSerializationFormat="yyyy-MM-ddTHH:mm:ssx"
                            value={form.checkOutTime}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Дата и время отгрузки" />
                            </Validator>
                          </DateBox>
                        </AppFiledBox>
                        <AppFiledBox label="Вес после отгрузки" labelTop>
                          <NumberBox
                            stylingMode="underlined"
                            placeholder="Введите вес после отгрузки"
                            //mode="number"
                            format="###0.##"
                            value={form.transportWeight}
                            min={0}
                            onValueChanged={(e: any) => {
                              setForm((prev) => ({ ...prev, transportWeight: e.value }));
                            }}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле вес после отгрузки" />
                            </Validator>
                          </NumberBox>
                        </AppFiledBox>
                      </AppGroup>
                    </AppRow>
                  </Item>
                </Form>
                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={handleHideModal}
                  disabledSubmit={isLoading}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default AutoFillModal;
